<template>
  <div class="print-tpl-box">
    <!-- ---------------------------watermark------------------------------------ -->
    <div id="bgimg" v-if="isCreditNote" v-show="false"><img class="bg-img" src="../assets/waterMarkNew.png" /></div>
    <div id="bgimg" v-if="!isCreditNote"></div>
    <!-- ---------------------------header------------------------------------ -->
    <div id="header">
      <div class="header">
        <div class="catption-box">
          <div v-if="!withOutPriceInfos" class="catption-title">{{getSheetTypeName()}}</div>
          <div v-if="withOutPriceInfos && !isCreditNote" class="catption-title">Delivery Doc.</div>
          <div v-if="withOutPriceInfos && isCreditNote" class="catption-title">Delivery Doc(Credit)</div>
          <!-- 需要根据公司账套信息进行切换 -->
          <!-- <div class="logo-box"><img class="logo-img" :src="printInfo.logo"/></div>
          <div class="logo-box">
            <img class="logo-img" width=180 height=26 src="../assets/printlogo.png"/>
          </div> -->
        </div>
        <div class="sub-header-box">

          <div class="right-info">
            <!-- 需要根据公司账套信息进行切换  -->
            <div class="right-info-caption">{{printInfo.name}}</div>
            <div>ABN {{printInfo.anb}}</div>
            <div v-if="!isBranchWarehouse">
              <div>{{printInfo.addressLine1}}</div>
              <div>{{printInfo.addressLine2}}</div>
            </div>
            <div>Tel: {{printInfo.phone}}</div>
            <div>Email:{{printInfo.email}}</div>
          </div>

          <div class="middle-info">
            <div class="bolder-text-first">Date</div>
            <div>{{dateFormatAu(date)}}</div>
            <div class="bolder-text" v-if="!isCreditNote">Invoice Number</div>
            <div class="bolder-text" v-if="isCreditNote">Credit Note No.</div>
            <div>{{number}}</div>
            <div v-if="isShowRefOrAbn" class="bolder-text">Reference</div>
            <div v-if="isShowRefOrAbn" class="ref-small-text">{{reference}}</div>
          </div>

          <div class="left-info">
              <div class="csr-name">{{csr.name}}</div>
              <!-- <div class="attention">Attention: {{payType}}</div> -->
              <div v-if="payType" class="attention">Payment Type: {{payType}}</div>
              <div>{{address}}</div>
              <div  v-if="isShowCsrABN" class="csr-abn-text">Client ABN: {{csr.code}}</div>
              <div>Phone: {{phone}}</div>
              <!-- <div v-if="abn">{{abn}}</div> -->
              <div v-if="!isPirelliLogis">Pay Type: <span class="Paytype">{{csr.paymentType}}</span></div>
              <div v-if="!isTyroolaApiRefShow">Area Type: <span class="Areatype">{{csr.areaType}}</span></div>
              <div v-if="isTyroolaApiRefShow">TY Reference: <span class="shipping">{{reference}}</span></div>
              <div>Shipping:
                <span :class="[isShipByPickUp?'shipping-big-text':'shipping']">{{getShipName}}</span>
                <span v-if="getDriver"> / {{getDriver}}</span>
              </div>
              <div v-if="isPirelliLogis">Reference: <span class="shipping">{{reference}}</span></div>
              <!-- <div v-if="csr.notes" class="shipping">Note: {{csr.notes}}</div> //应Mac要求取消 -->
              <div v-if="status==='Draft'">{{status}} for Fetch</div>
              <!-- <div v-if="isMelbourneAndNewwarehouse">Outbound: <span class="shipping">New Warehouse</span></div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- ---------------------------lines content------------------------------------ -->
    <div id="line-content">
      <div class="line-items" >
        <div v-if="!withOutPriceInfos">
          <table class="line-table" width="100%" cellspacing="0" cellpadding="0">
            <thead v-if="!isDisplayLocation"><tr>
              <td class="lines-table-head" width="52%">Description</td>
              <td class="lines-table-head" width="11%" align="right">Qty.</td>
              <td class="lines-table-head" width="12%" align="right">Price</td>
              <td class="lines-table-head" width="11%" align="right">GST</td>
              <td class="lines-table-head" width="14%" align="right">Amount</td></tr>
            </thead>
            <thead v-if="isDisplayLocation"><tr>
              <td class="lines-table-head" width="50%">Description</td>
              <td class="lines-table-head" width="9%" align="right">Qty.</td>
              <td class="lines-table-head" width="11%" align="right">Price</td>
              <td class="lines-table-head" width="10%" align="right">GST</td>
              <td class="lines-table-head" width="11%" align="right">Amount</td>
              <td class="lines-table-head location-head-small" width="6%" align="right">Loc.&nbsp;&nbsp;</td></tr>
            </thead>

            <tbody v-if="isExclusiveGST">
              <tr v-for="(item, index) in tableData" :key="index">
                <td class="lines-table-body">{{item.product.name}}</td>
                <td class="lines-table-body" align="right">{{item.quantity}}</td>
                <td class="lines-table-body" align="right">{{divideAndRound(item.price)}}</td>
                <td class="lines-table-body" align="right">10% </td>
                <td class="lines-table-body amt-line-column" align="right">{{divideAndRound(item.line_amount)}}</td>
                <td class="lines-table-body location-line-small" align="right" v-if="isDisplayLocation">{{locationTextHandle(item.product.tag4)}}</td>
              </tr>
            </tbody>
            <tbody v-if="!isExclusiveGST">
              <tr v-for="(item, index) in tableData" :key="index">
                <td class="lines-table-body">{{item.product.name}}</td>
                <td class="lines-table-body" align="right">{{item.quantity}}</td>
                <td class="lines-table-body" align="right">{{item.price}}</td>
                <td class="lines-table-body" align="right">10%</td>
                <td class="lines-table-body amt-line-column" align="right">{{item.line_amount}}</td>
                <td class="lines-table-body location-line-small" align="right" v-if="isDisplayLocation">{{locationTextHandle(item.product.tag4)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="withOutPriceInfos">
          <table class="line-table" width="100%" cellspacing="0" cellpadding="0">
              <thead v-if="!isDisplayLocation"><tr>
              <td class="lines-table-head" width="52%">Description</td>
              <td class="lines-table-head" width="12%" align="right">Qty.</td>
              <td class="lines-table-head" width="12%" align="right">Price</td>
              <td class="lines-table-head" width="12%" align="right">GST</td>
              <td class="lines-table-head" width="12%" align="right">Amount</td></tr>
            </thead>
              <thead v-if="isDisplayLocation"><tr>
              <td class="lines-table-head" width="52%">Description</td>
              <td class="lines-table-head" width="12%" align="right">Qty.</td>
              <td class="lines-table-head" width="12%" align="right">Price</td>
              <td class="lines-table-head" width="12%" align="right">GST</td>
              <td class="lines-table-head location-head-small" width="12%" align="right">Loc.&nbsp;&nbsp;</td></tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in tableData" :key="index">
                <td class="lines-table-body">{{item.product.name}}</td>
                <td class="lines-table-body" align="right">{{item.quantity}}</td>
                <td class="lines-table-body" align="center">--</td>
                <td class="lines-table-body" align="center">--</td>
                <td class="lines-table-body" align="center" v-if="!isDisplayLocation">--</td>
                <td class="lines-table-body location-line-small" align="right" v-if="isDisplayLocation">{{locationTextHandle(item.product.tag4)}}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- ---------------------------lines total------------------------------------ -->
    <div id="lines-total">
      <div class="lines-total">
        <div class="lines-total-grey-box">
          <div v-if="!isWerribeeKIAandCommentNull" class="comment">Comment: {{comments}}</div>
          <div v-if="isWerribeeKIAandCommentNull" class="comment">Comments: {{reference}}</div>
          <div class="lines-total-grey"><span>Total Quantity&nbsp;&nbsp;&nbsp;</span><b>{{totalAmount}}</b></div>
        </div>
        <div v-if="!withOutPriceInfos && isExclusiveGST"><span>Subtotal&nbsp;&nbsp;&nbsp;</span><b>{{divideAndRound(totalPrice)}}</b></div>
        <div v-if="!withOutPriceInfos"><span>TOTAL GST 10%&nbsp;&nbsp;&nbsp;</span><b>{{includesGstForPrint}}</b></div>
        <!-- <div class="lines-total-divider"></div> -->
        <div v-if="!withOutPriceInfos && !isCreditNote" class="lines-total-stong"><span>TOTAL AUD&nbsp;&nbsp;&nbsp;</span>{{totalPrice}}</div>
        <div v-if="!withOutPriceInfos && isCreditNote" class="lines-total-stong"><span>TOTAL CREDIT&nbsp;&nbsp;&nbsp;</span>{{totalPrice}}</div>
      </div>
      <div class="due-date-area" v-if="!withOutPriceInfos && !isCreditNote">
        <div class="due-date-text"><span>Due Date: </span>{{dateFormatAu(dueDate)}}</div>
        <div class="static-info2">
          <div>Account Name: {{printInfo.bankAccountName}}</div>
          <div>BSB: {{printInfo.bsb}}&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;AccNo: {{printInfo.bankAccount}}</div>
          <!-- <div class="due-date-small-text">*Pricing subject to change as new stock arrives, due to flutuations in the AUD</div> -->
        </div>
      </div>
    </div>
    <!-- ---------------------------footer content------------------------------------ -->
    <div id="footer">
      <div class="footer-stick-bottom">
        <div class="footer-sign-text">
          <!-- <span>Staff Sign ___________________________&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> -->
          <span>Customer Sign:</span>
        </div>
        <div class="divider-line"></div>
        <div class="footer">
          <div class="footer-right"><table class="tg">
            <tr>
              <td width="40%" class="bolder-table-text">Staff</td>
              <td width="60%" class="tg-z4i2">{{getStaff}}</td>
            </tr>
            <tr>
              <td width="40%" class="bolder-table-text">Customer</td>
              <td width="60%" class="tg-z4i2">{{csr.name}}</td>
            </tr><tr>
                <td class="bolder-table-text" v-if="!isCreditNote">Invoice Number</td>
                <td class="bolder-table-text" v-if="isCreditNote">Credit Note #</td>
                <td class="tg-z4i2">{{number}}</td>
            </tr><tr v-if="!withOutPriceInfos && !isCreditNote">
                <td class="bolder-table-text">Amount Due</td>
                <td class="tg-z4i2">{{totalPrice}}</td>
            </tr><tr v-if="!withOutPriceInfos && isCreditNote">
                <td class="bolder-table-text">Total Credit</td>
                <td class="tg-z4i2">{{totalPrice}}</td>
            </tr><tr v-if="!isCreditNote">
                <td class="bolder-table-text" >Due Date</td>
                <td class="tg-z4i2">{{dateFormatAu(dueDate)}}</td>
            </tr>
            <!-- <div v-if="!isExclusiveGST">
              <tr v-if="!isCreditNote">
                  <td class="bolder-table-text">Amount<br>Enclosed</td>
                  <td class="underscore"></td>
              </tr>
              <tr v-if="!isCreditNote">
                <td></td>
                <td class="smallest-text">Enter the amount you are paying above</td>
              </tr>
            </div> -->
            <div v-if="isExclusiveGST">
              <tr v-if="!isCreditNote">
                  <td class="bolder-table-text">Picked by</td>
                  <td class="underscore"></td>
              </tr>
              <tr v-if="!isCreditNote">
                  <td class="bolder-table-text">Checked by</td>
                  <td class="underscore"></td>
              </tr>
            </div>
            </table>
          </div>
          <div v-if="!isCreditNote" class="footer-left">
            <div class="payment-info">PAYMENT ADVICE</div>
            <div class="payment-static-info">
                <div>Account Name: {{printInfo.bankAccountName}}</div>
                <div>BSB: {{printInfo.bsb}}</div>
                <div>Account Number: {{printInfo.bankAccount}}</div>
                <!-- <div>{{printInfo.name}}</div> -->
                <!-- 判断是不是Wollongong  -->
                <div v-if="!isBranchWarehouse">
                  <div>{{printInfo.addressLine1}}</div>
                  <div>{{printInfo.addressLine2}}</div>
                </div>
                <div v-if="isBranchWarehouse">
                  <div>123 Flagstaff Rd, </div>
                  <div>Warrawong NSW 2502</div>
                </div>
            </div>
          </div>
          <div v-if="isCreditNote" class="footer-left">
            <div class="payment-info">CREDIT ADVICE</div>
              <div class="payment-static-info">
                <div>Please do not pay on this advice.</div>
                <div>Deduct the amount of this Credit Note</div>
                <div>from your next payment to us.</div>
            </div>
          </div>
        </div>
        <!-- 需要根据公司账套信息进行切换 //TODO -->
        <!-- <div class="end-of-page" v-if="!isDisplayReturnInfo">
            <span>ABN: {{printInfo.anb}}. Office: </span>
            <span>{{isBranchWarehouse?'123 Flagstaff Rd ': printInfo.addressLine1}}, </span>
            <span>{{isBranchWarehouse?'Warrawong NSW 2502': printInfo.addressLine2}}, Australia.</span>
        </div> -->
        <div class="end-of-page">
            <B>Return Policy</B>: Free returns within 48 hours. Returns within 7 days will incur a 10% restocking fee. No returns accepted after 7 days.&nbsp;&nbsp;
            <!-- <span class="endpage-small">Received By: Name______________________ Signature: _____________________ Date:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'PrintTplStandard',
  data () {
    return {
      isCreditNote: false
    }
  },
  created () {
  },
  props: {
    withOutPriceInfos: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('edit', {
      tableData: 'lines',
      csr: 'csr',
      number: 'no',
      payType: 'csr.payType',
      address: 'address',
      phone: 'phone',
      date: 'date',
      dueDate: 'dueDate',
      shipType: 'shipType',
      csrServiceId: 'csrServiceId',
      driverId: 'driverId',
      warehouseId: 'warehouseId',
      orderType: 'type',
      comments: 'comments',
      reference: 'reference',
      status: 'status'
    }),
    ...mapState({
      printInfo: 'printInfo'
    }),
    ...mapGetters({
      totalAmount: 'edit/totalAmount',
      totalPrice: 'edit/totalPrice',
      includesGstForPrint: 'edit/includesGstForPrint',
      getShipTypeName: 'getShipTypeName',
      getStaffName: 'getStaffName',
      dateFormatAu: 'dateFormatAu'
    }),
    // getLogoImgUrl () {
    //   return '../assets/printLogoCompany1.jpg'
    // },
    isExclusiveGST () {
      if (this.printInfo.department_id === 7 || this.printInfo.department_id === 8) {
        return true
      } else {
        return false
      }
    },
    isShowCsrABN () {
      if (this.csr.code.length <= 14 && this.csr.code.length > 7 && !this.csr.code.toLowerCase().includes('c')) {
        return true
      } else {
        return false
      }
    },
    isShowRefOrAbn () {
      if (this.printInfo.department_id === 7 || this.printInfo.department_id === 8 || this.printInfo.department_id === 12) {
        return true
      } else {
        return false
      }
    },
    isBranchWarehouse () {
      if (this.warehouseId === 14) {
        return true
      } else {
        return false
      }
    },
    NSWnotice () {
      return this.printInfo.department_id === 10
    },
    isMelbourneAndNewwarehouse () {
      if (this.printInfo.department_id === 4 && this.warehouseId === 20) {
        return true
      } else {
        return false
      }
    },
    isWerribeeKIAandCommentNull () {
      if (this.csr.name.toLowerCase().includes('werribee hyundai') && this.comments === '') {
        return true // 专门针对David的客户打印备注时
      } else {
        return false
      }
    },
    isPirelliLogis () {
      if (this.printInfo.name.toLowerCase().includes('pirelli')) {
        return true
      } else {
        return false
      }
    },
    isDisplayLocation () {
      const hasLocText = (obj) => {
        return obj.product.tag4 !== ''
      }
      let isLocExisting = this.tableData.some(hasLocText)

      if (isLocExisting) {
        return true
      } else {
        return false
      }
    },
    isDisplayReturnInfo () {
      if (this.printInfo.department_id >= 7) {
        return true
      } else {
        return false
      }
    },
    isTyroolaApiRefShow () {
      // 满足来自Tyroola的API下单时，显示ref
      const dpt = this.printInfo.department_id === 4 || this.printInfo.department_id === 10
      const isTY = this.csr.name.toLowerCase().includes('tyroola')
      if (dpt && isTY) {
        return true
      } else {
        return false
      }
    },
    getShipName () {
      return this.getShipTypeName(this.shipType)
    },
    isShipByPickUp () {
      return Number.parseInt(this.shipType) === 2
    },
    getStaff () {
      return this.getStaffName(this.csrServiceId) || ''
    },
    getDriver () {
      return this.getStaffName(this.driverId) || ''
    }
  },
  methods: {
    divideAndRound (val) {
      let num = val / 1.1
      num = num.toFixed(2)
      return num || '0'
    },
    getSheetTypeName () {
      if (this.orderType === 1) {
        this.isCreditNote = false
        return 'TAX INVOICE'
      } else if (this.orderType === 2) {
        this.isCreditNote = true
        return 'CREDIT NOTE'
      } else {
        return ''
      }
    },
    locationTextHandle (text) {
      if (text.toLowerCase() === 'call') {
        return ''
      } else {
        return text
      }
    }
  }
}
</script>
